<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { sleep } from '@/util'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('system', ['routerStatusRedirect']),
    ...mapState('contract', ['current']),
  },
  methods: {
    ...mapActions('contract', ['getCurrent']),
    async pollCurrent() {
      const current = await this.getCurrent()
      if (!current?.uuid) {
        await sleep(500)
        await this.pollCurrent()
      }
    },
  },
  async created() {
    console.log(`status check ${this.resultName}`)
    await this.pollCurrent()

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
}
</script>
